import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import style from "./style.module.scss";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
/**
 * OptionFeedback:
 *  - Feedback message for a particular Option
 */
export function OptionFeedback(props) {
  const intl = useIntl();
  if (props.visible) {
    const feedbackTextStr = props.isCorrect ? "Correct: " : "Not quite: ";

    const feedbackText = intl.formatMessage({
      id: feedbackTextStr,
      defaultMessage: feedbackTextStr,
      description: "",
    });
    const text = typeof props.text === "string" ? props.text : props.text.value;

    // Generate unique ID for this feedback element
    const feedbackId = props.feedbackId || `option-feedback-${props.optionId}`;

    return (
      <div className={`${style.feedback} ${props.className}`} dir="auto">
        {text && (
          <div id={feedbackId} role="alert" aria-live="polite">
            {!props.OnlyString && <b>{feedbackText}</b>}
            <RichText value={text} equation={true}/>
          </div>
        )}
      </div>
    );
  } else return null;
}

OptionFeedback.propTypes = {
  /**
   * Boolean specifying if feedback is for correct
   */
  isCorrect: PropTypes.bool,
  /**
   * Boolean specifying if feedback is visible
   */
  visible: PropTypes.bool.isRequired,
  /**
   * text to be displayed as feedback
   */
  text: PropTypes.string.isRequired,
  /**
   * className to be set for feedback element
   */
  className: PropTypes.string,
  /**
   * Boolean to control whether to show feedbackTextStr prefix
   */
  OnlyString: PropTypes.bool,
  /**
   * Unique ID of the option this feedback belongs to
   */
  optionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Custom feedback element ID (optional, auto-generated if not provided)
   */
  feedbackId: PropTypes.string,
};

OptionFeedback.defaultProps = {
  isCorrect: false,
  visible: false,
  text: "",
  OnlyString: false,
};
